// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hx","cusMtdicon":"hx"};